import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { MORE_768_MEDIA_QUERY } from '../../../../../consts/adaptive';
import { cssToObject } from '../../../../../../utils/cssToObject';

const linesClampStyles = (linesAmount: number) => {
  return {
    display: '-webkit-box',
    overflow: 'hidden',
    textDecoration: 'inherit',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': linesAmount,
    lineClamp: linesAmount,
    '-webkit-box-orient': 'vertical',
  };
};

export const styles = {
  infoColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  roomName: {
    margin: '0 0 1rem 0',
    color: defaultTheme.theme.colorVariables.textDark,
    ...cssToObject(defaultTheme.theme.mixin.fontSubtitleS),
  },
  roomParams: {
    margin: '0 0 0.75rem 0',
    color: defaultTheme.theme.colorVariables.textNoteDark,
    ...cssToObject(defaultTheme.theme.mixin.fontTextXS),
  },
  roomDescription: {
    ...cssToObject(defaultTheme.theme.mixin.fontTextS),
    color: defaultTheme.theme.colorVariables.textDark,
    margin: 0,
  },

  [MORE_768_MEDIA_QUERY]: {
    infoColumn: {
      width: 'calc(50% - 0.75rem)',
    },
    roomName: {
      margin: '0 0.5rem 0.75rem 0',
      maxHeight: '48px', // 2 lines for Safari
      ...linesClampStyles(2),
    },
    roomDescription: {
      maxHeight: '164px', // 9 lines for Safari
      ...linesClampStyles(9),
    },
  }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
